import React, { useRef, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { isMobile } from "react-device-detect";
import Transition from "./Transition";
import useAuth from "../auth/useAuth";
import {
  FaHome,
  FaPrint,
  FaUsers,
  FaWarehouse,
  FaIndustry,
  FaSun,
  FaCog,
} from "react-icons/fa";
import AuthContext from "../auth/context";

function NavBar({ content }) {
  const loc = useLocation();
  const { logOut } = useAuth();
  const [isDark, setIsDark] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [toggled, setToggled] = useState(false);

  const { user } = useContext(AuthContext);

  return (
    <>
      <div
        className={!toggled && !isMobile ? "drawer lg:drawer-open" : "drawer"}
      >
        {(!toggled || isMobile) && (
          <input id="my-drawer-3" type="checkbox" className="drawer-toggle" />
        )}

        <div className="drawer-content flex flex-col">
          {/* Navbar */}
          <div
            className={
              !isVisible
                ? "hidden"
                : isDark
                ? "navbar h-18 fixed z-10 bg-white border-b border-gray-100"
                : "navbar h-18 fixed z-10 bg-white border-b border-gray-100"
            }
          >
            <div className="flex-none" onClick={() => setToggled(!toggled)}>
              <label htmlFor="my-drawer-3" className="btn btn-ghost btn-circle">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  className="inline-block w-6 h-6 stroke-current"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  ></path>
                </svg>
              </label>
            </div>

            <div className="flex-1">
              {(toggled || isMobile) && (
                <Transition
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0 }}
                >
                  <Link
                    to="/"
                    className="btn btn-ghost text-xl text-black hover:bg-transparent hover:text-gray-500 hover:border-white ml-5"
                  >
                    <img
                      src={"/graziani.png"}
                      width="100"
                      height="50"
                      alt="Logo"
                      className="object-contain"
                    />
                  </Link>
                </Transition>
              )}
            </div>

            <div
              className="flex-none pr-2"
              style={{ marginRight: !toggled && !isMobile ? "190px" : "0px" }}
            >
              <a onClick={logOut} className="btn btn-ghost">
                Logout
              </a>
            </div>
          </div>

          <main className="light text-foreground bg-gray-50 mt-16 p-2 flex-1">
            {content}
          </main>
        </div>

        <div className="drawer-side z-20">
          <label htmlFor="my-drawer-3" className="drawer-overlay"></label>

          <ul className="space-y-2 font-medium menu p-4 w-80 sm:w-48 min-h-full bg-white text-gray-700 border-r border-gray-100">
            <img
              src={"/graziani.png"}
              height="200"
              alt="Logo"
              className="object-contain self-center mb-14 mt-2 px-5"
            />

            <li>
              <Link
                to="/"
                className={`flex flex-col ${
                  loc.pathname === "/" ? "bg-gray-300" : ""
                }`}
              >
                <FaHome className="w-8 h-8 text-gray-500 group-hover:text-primary" />
                <span className="">Dashboard</span>
              </Link>
            </li>

            <li>
              <Link to="/operatori" className="flex flex-col">
                <FaUsers className="w-8 h-8 text-gray-500 group-hover:text-primary" />
                <span className="">Utenti</span>
              </Link>
            </li>

            <li>
              <Link to="/server-logs" className="flex flex-col">
                <FaPrint className="w-8 h-8 text-gray-500 group-hover:text-primary" />
                <span className="">Log</span>
              </Link>
            </li>

            <span className="absolute bottom-5 left-0 w-full text-gray-500 font-light text-xs text-center">
              Made by FAST IT
              <br />
              <a href="https://fast-it.org" target="_blank">
                www.fast-it.org
              </a>
            </span>
          </ul>
        </div>
      </div>
    </>
  );
}

export default NavBar;
